import { render } from "./IconMobile.vue?vue&type=template&id=7d3b36f3"
const script = {}
script.render = render

export default script